import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CurrentUser, CurrentUserFromJSON } from "../../bitmaker";

type PrivateRouteProps = {
  children: React.ReactNode;
};

const routePermissionMap: {
  [key: string]: keyof CurrentUser["permissions"];
} = {
  "/sales": "can_access_sales",
  "/leads": "can_access_leads",
  "/invoices": "can_access_invoices",
  "/users": "can_access_members_information",
  "/audit": "can_access_audit",
  "/billing": "can_access_billing",
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState<
    CurrentUser["permissions"] | null
  >(null);
  const [checkedAccess, setCheckedAccess] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const retrievedUserJSON = window.localStorage.getItem("bmCurrentUser");
    if (retrievedUserJSON) {
      const user = CurrentUserFromJSON(JSON.parse(retrievedUserJSON));
      setUserPermissions(user.permissions);
    }
    setCheckedAccess(true);
  }, []);

  if (!checkedAccess) {
    return null;
  }

  const currentPath = location.pathname;
  const pathSegments = currentPath.split("/").filter(Boolean);
  const baseRoute = "/" + (pathSegments[0] || "");

  const requiredPermissionKey = routePermissionMap[baseRoute];

  if (!userPermissions) {
    return <Navigate to="/" replace />;
  }

  let hasPermission = true;

  if (requiredPermissionKey) {
    hasPermission = !!userPermissions[requiredPermissionKey];
  }

  if (hasPermission) {
    return <>{children}</>;
  } else {
    return <Navigate to="/" replace />;
  }
};

export default PrivateRoute;
